import { useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import WebsiteLogo from '../WebsiteLogo';
import ThemeToggle from '../ThemeToggle';
import { ADMIN_LOGIN_PATH } from '../../helper/authPaths';

const CLICK_WINDOW_MS = 500;
const SECRET_CLICKS = 3;

const navClass = ({ isActive }) =>
    `text-sm font-medium transition-colors duration-tesla ${isActive
        ? 'text-ink dark:text-white'
        : 'text-muted hover:text-ink dark:hover:text-white'
    }`;

const PublicHeader = () => {
    const navigate = useNavigate();
    const clickCountRef = useRef(0);
    const resetTimerRef = useRef(null);

    const handleLogoClick = (event) => {
        clickCountRef.current += 1;

        if (resetTimerRef.current) {
            window.clearTimeout(resetTimerRef.current);
        }

        if (clickCountRef.current >= SECRET_CLICKS) {
            event.preventDefault();
            clickCountRef.current = 0;
            navigate(ADMIN_LOGIN_PATH);
            return;
        }

        resetTimerRef.current = window.setTimeout(() => {
            clickCountRef.current = 0;
        }, CLICK_WINDOW_MS);
    };

    return (
        <header className="public-header">
            <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6 md:py-4">
                <NavLink
                    to="/"
                    className="shrink-0 select-none"
                    onClick={handleLogoClick}
                    aria-label="Beranda"
                >
                    <WebsiteLogo
                        alt="Logo universitas"
                        className="h-9 w-auto max-w-[180px] object-contain sm:h-10 sm:max-w-[220px]"
                    />
                </NavLink>

                <nav className="hidden items-center gap-6 md:flex">
                    <NavLink to="/" end className={navClass}>
                        Beranda
                    </NavLink>
                    <a href="/#jurnal" className={navClass({ isActive: false })}>
                        Jurnal
                    </a>
                    <a href="/#layanan" className={navClass({ isActive: false })}>
                        Layanan
                    </a>
                    <a href="/#verifikasi" className={navClass({ isActive: false })}>
                        Verifikasi
                    </a>
                </nav>

                <div className="flex items-center gap-2">
                    <ThemeToggle />
                </div>
            </div>
        </header>
    );
};

export default PublicHeader;
